var _circle, _circle2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoodFinishMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20,
    cy: 20,
    r: 7.5,
    fill: "#1D1D1F",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H25C33.0081 0.5 39.5 6.99187 39.5 15V38C39.5 38.8284 38.8284 39.5 38 39.5H2C1.17157 39.5 0.5 38.8284 0.5 38V2Z",
    fill: "#C9B293",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2067 17.7969C21.9998 17.7969 21.832 17.9646 21.832 18.1716V25.2535C21.832 25.4603 21.9998 25.6282 22.2067 25.6282C22.4137 25.6282 22.5814 25.4603 22.5814 25.2535V18.1716C22.5814 17.9646 22.4137 17.7969 22.2067 17.7969Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7858 17.7969C17.5789 17.7969 17.4111 17.9646 17.4111 18.1716V25.2535C17.4111 25.4603 17.5789 25.6282 17.7858 25.6282C17.9928 25.6282 18.1605 25.4603 18.1605 25.2535V18.1716C18.1605 17.9646 17.9928 17.7969 17.7858 17.7969Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5632 16.7634V25.9953C14.5632 26.541 14.7633 27.0534 15.1129 27.4211C15.4608 27.7898 15.945 27.9991 16.4517 28H23.5413C24.0481 27.9991 24.5323 27.7898 24.8801 27.4211C25.2296 27.0534 25.4297 26.541 25.4297 25.9953V16.7634C26.1245 16.5789 26.5748 15.9077 26.4818 15.1947C26.3887 14.4819 25.7815 13.9487 25.0625 13.9485H23.144V13.4801C23.1462 13.0863 22.9905 12.708 22.7116 12.4298C22.4328 12.1517 22.054 11.9968 21.6601 12H18.3329C17.939 11.9968 17.5602 12.1517 17.2813 12.4298C17.0025 12.708 16.8468 13.0863 16.849 13.4801V13.9485H14.9305C14.2115 13.9487 13.6042 14.4819 13.5111 15.1947C13.4182 15.9077 13.8684 16.5789 14.5632 16.7634ZM23.5413 27.2506H16.4517C15.8111 27.2506 15.3127 26.7002 15.3127 25.9953V16.7963H24.6803V25.9953C24.6803 26.7002 24.1819 27.2506 23.5413 27.2506ZM17.5984 13.4801C17.5959 13.285 17.6726 13.0972 17.811 12.9595C17.9494 12.8218 18.1376 12.7461 18.3329 12.7495H21.6601C21.8554 12.7461 22.0436 12.8218 22.1819 12.9595C22.3204 13.0971 22.3971 13.285 22.3946 13.4801V13.9485H17.5984V13.4801ZM14.9305 14.6979H25.0625C25.435 14.6979 25.737 14.9999 25.737 15.3724C25.737 15.7449 25.435 16.0469 25.0625 16.0469H14.9305C14.558 16.0469 14.256 15.7449 14.256 15.3724C14.256 14.9999 14.558 14.6979 14.9305 14.6979Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9958 17.7969C19.7888 17.7969 19.6211 17.9646 19.6211 18.1716V25.2535C19.6211 25.4603 19.7888 25.6282 19.9958 25.6282C20.2028 25.6282 20.3705 25.4603 20.3705 25.2535V18.1716C20.3705 17.9646 20.2028 17.7969 19.9958 17.7969Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoodFinishMobile);
export default __webpack_public_path__ + "static/media/wood-finish-mobile.c462a45af2e572f90d36babca2a8a473.svg";
export { ForwardRef as ReactComponent };